import { render } from "./PuzzleList.vue?vue&type=template&id=0c1a2c66&scoped=true"
import script from "./PuzzleList.vue?vue&type=script&lang=js"
export * from "./PuzzleList.vue?vue&type=script&lang=js"

import "./PuzzleList.vue?vue&type=style&index=0&id=0c1a2c66&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1a2c66"]])

export default __exports__